import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './BackButton.css';

const BackButton = ({ label = 'Voltar', onClick, ...props }) => {
    const navigate = useNavigate();

    const handleBack = (e) => {
        if (onClick) {
            onClick(e);
        } else {
            navigate(-1);
        }
    };

    return (
        <button
            className="btn-back-standard"
            onClick={handleBack}
            title="Voltar para a tela anterior"
            {...props}
        >
            <FaArrowLeft className="btn-back-icon" />
            {label}
        </button>
    );
};

export default BackButton;
